export default __webpack_public_path__ + "static/media/u.c843e610.png";